var _circle, _path, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEstate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EAF9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.474 34h-6.369a1 1 0 01-1-1V22.421m0 0l7.758-6.788a1 1 0 011.323.006l3.55 3.156m-12.63 3.626L14 24m20-.526l-1.053-.936m0 0V15a1 1 0 00-1-1h-2.21a1 1 0 00-1 1v3.795m4.21 3.743l-4.21-3.743",
    stroke: "#5DB39D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 3,
    stroke: "#5DB39D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.293 34.707a1 1 0 001.414-1.414l-1.414 1.414zm-2-2l2 2 1.414-1.414-2-2-1.414 1.414z",
    fill: "#5DB39D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFQUY5RjciLz4KPHBhdGggZD0iTTIzLjQ3MzcgMzRIMTcuMTA1M0MxNi41NTMgMzQgMTYuMTA1MyAzMy41NTIzIDE2LjEwNTMgMzNWMjIuNDIxMU0xNi4xMDUzIDIyLjQyMTFMMjMuODYyNiAxNS42MzM0QzI0LjI0MTkgMTUuMzAxNSAyNC44MDg4IDE1LjMwMzcgMjUuMTg1NSAxNS42Mzg1TDI4LjczNjggMTguNzk1M00xNi4xMDUzIDIyLjQyMTFMMTQgMjRNMzQgMjMuNDczN0wzMi45NDc0IDIyLjUzOE0zMi45NDc0IDIyLjUzOFYxNUMzMi45NDc0IDE0LjQ0NzcgMzIuNDk5NyAxNCAzMS45NDc0IDE0SDI5LjczNjhDMjkuMTg0NiAxNCAyOC43MzY4IDE0LjQ0NzcgMjguNzM2OCAxNVYxOC43OTUzTTMyLjk0NzQgMjIuNTM4TDI4LjczNjggMTguNzk1MyIgc3Ryb2tlPSIjNURCMzlEIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzIiBzdHJva2U9IiM1REIzOUQiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMzMuMjkyOSAzNC43MDcxQzMzLjY4MzQgMzUuMDk3NiAzNC4zMTY2IDM1LjA5NzYgMzQuNzA3MSAzNC43MDcxQzM1LjA5NzYgMzQuMzE2NiAzNS4wOTc2IDMzLjY4MzQgMzQuNzA3MSAzMy4yOTI5TDMzLjI5MjkgMzQuNzA3MVpNMzEuMjkyOSAzMi43MDcxTDMzLjI5MjkgMzQuNzA3MUwzNC43MDcxIDMzLjI5MjlMMzIuNzA3MSAzMS4yOTI5TDMxLjI5MjkgMzIuNzA3MVoiIGZpbGw9IiM1REIzOUQiLz4KPC9zdmc+Cg==";
export { SvgEstate as ReactComponent };